// Resource type label keys for use with t() from react-i18next.
// NB: TYPE_LABEL_PLURAL is still referenced for legacy compat — use t() in components.
import type { ResourceType } from "./reservations.schemas";

export const TYPE_LABEL_KEY: Record<ResourceType, string> = {
  room: "reservations.resTypeRoom",
  workplace: "reservations.resTypeWorkplace",
};

export const TYPE_LABEL_PLURAL_KEY: Record<ResourceType, string> = {
  room: "reservations.typeRoomPlural",
  workplace: "reservations.typeWorkplacePlural",
};

// Fixed list of physical Willems sites (vestigingen). Mirror of the backend copy
// in services/api reservationResources.service.ts — keep the two in sync.
export const RESERVATION_BRANCHES = [
  "Willems Logistics Rijkevoort",
  "Willems Logistics Waalwijk",
  "WLS DC Borculo",
  "WLS DC DH3725",
  "WLS DC De Kempkens",
  "Willems Logistics Haps",
  "Willems Logistics MW8",
] as const;

// Booking horizon for recurring series — mirror of the API's
// RESERVATION_BOOKING_WINDOW_DAYS (default 365, matches the harmonized Exchange
// BookingWindowInDays). Used to cap the "until" date picker; the server enforces
// it authoritatively. See docs/recurring-reservations-mvp.md §3.1.
export const BOOKING_WINDOW_DAYS = 365;
